import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import ConfigProperty from "./ConfigProperty";
import { IMenuItemOptionVariant } from "../MenuDetailModel";
var ConfigOption = (_dec = observable.ref, _dec2 = observable.shallow, (_class = /*#__PURE__*/function () {
  _createClass(ConfigOption, [{
    key: "options",
    get: function get() {
      return this._configProperties;
    }
  }, {
    key: "depth",
    get: function get() {
      return this._parent.depth + 1;
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "makeOptionsAsListWithCarousels",
    get: function get() {
      var _this$_parent;

      return (_this$_parent = this._parent) === null || _this$_parent === void 0 ? void 0 : _this$_parent.options.some(function (opt) {
        var _opt$options;

        return (opt === null || opt === void 0 ? void 0 : (_opt$options = opt.options) === null || _opt$options === void 0 ? void 0 : _opt$options.length) >= 2;
      });
    }
  }, {
    key: "variant",
    get: function get() {
      var propertyVariant = this._parent.variant;
      var options = this._configProperties;
      var optionType = this.optionType;

      if (this.depth === 2) {
        if ((optionType === null || optionType === void 0 ? void 0 : optionType.toLowerCase()) === "no") return IMenuItemOptionVariant.BUTTON_REMOVE_ITEM;

        if (propertyVariant === "ACCORDION_WITH_LIST") {
          if (this.floor === 4) {
            return IMenuItemOptionVariant.LIST_ITEM_WITH_ONE_CAROUSEL;
          }

          if (!(options !== null && options !== void 0 && options.length)) {
            return IMenuItemOptionVariant.LIST_ITEM;
          } else if ((options === null || options === void 0 ? void 0 : options.length) === 1) {
            return IMenuItemOptionVariant.LIST_ITEM_WITH_ONE_SLIDER;
          } else if ((options === null || options === void 0 ? void 0 : options.length) > 1) {
            return IMenuItemOptionVariant.LIST_ITEM_WITH_MULTIPLE_SLIDERS;
          }
        } else if (propertyVariant === "ACCORDION_WITH_CAROUSEL") {
          if (!(options !== null && options !== void 0 && options.length)) {
            return IMenuItemOptionVariant.CAROUSEL_ITEM;
          } else if ((options === null || options === void 0 ? void 0 : options.length) >= 1) {
            return IMenuItemOptionVariant.CAROUSEL_ITEM_WITH_SLIDER;
          }
        }
      }

      if (this.depth === 4 && propertyVariant === "CAROUSEL_WITH_HEADER") {
        if (!(options !== null && options !== void 0 && options.length)) return IMenuItemOptionVariant.CAROUSEL_ITEM;
        if ((options === null || options === void 0 ? void 0 : options.length) >= 1) return IMenuItemOptionVariant.CAROUSEL_ITEM_WITH_SLIDER;
      }

      return IMenuItemOptionVariant.SLIDER_ITEM;
    }
  }, {
    key: "floor",
    get: function get() {
      if (this._configProperties && this._configProperties.length > 0) {
        var maxFloor = 0;

        this._configProperties.forEach(function (opt) {
          if (opt.floor > maxFloor) {
            maxFloor = opt.floor;
          }
        });

        return maxFloor + 1;
      } else {
        return 0;
      }
    }
  }, {
    key: "pretty",
    get: function get() {
      var _this$_configProperti;

      return {
        isInValid: this.isInValid,
        selected: this.selected,
        optionId: this.optionId,
        displayName: this.displayName,
        name: this.name,
        price: this.price,
        displayPrice: this.displayPrice,
        selectedId: this.selectedId,
        optionType: this.optionType,
        description: this.description,
        depth: this.depth,
        floor: this.floor,
        variant: this.variant,
        properties: (_this$_configProperti = this._configProperties) === null || _this$_configProperti === void 0 ? void 0 : _this$_configProperti.map(function (prop) {
          return prop.pretty;
        })
      };
    }
  }]);

  function ConfigOption(rawSkuBean, parent) {
    _classCallCheck(this, ConfigOption);

    _initializerDefineProperty(this, "_skuBean", _descriptor, this);

    _defineProperty(this, "_parent", void 0);

    _initializerDefineProperty(this, "_configProperties", _descriptor2, this);

    _initializerDefineProperty(this, "_selected", _descriptor3, this);

    makeObservable(this);
    this._parent = parent;
    this.setRawSkuBean(rawSkuBean);
  }

  _createClass(ConfigOption, [{
    key: "processConfigPropertyEntries",
    value: function processConfigPropertyEntries() {
      var _this = this;

      runInAction(function () {
        var _this$_skuBean, _this$_skuBean$config;

        _this._configProperties = (_this$_skuBean = _this._skuBean) === null || _this$_skuBean === void 0 ? void 0 : (_this$_skuBean$config = _this$_skuBean.configurationProperty) === null || _this$_skuBean$config === void 0 ? void 0 : _this$_skuBean$config.reduce(function (res, rawPropertyBean) {
          var configProp = new ConfigProperty(rawPropertyBean, _this);

          if (!configProp.isEmpty) {
            res.push(configProp);
          }

          return res;
        }, []);
      });
    }
  }, {
    key: "setRawSkuBean",
    value: function setRawSkuBean(rawSkuBean) {
      var _this2 = this;

      runInAction(function () {
        _this2._skuBean = rawSkuBean;
      });
      this.processConfigPropertyEntries();
    }
  }, {
    key: "clearTree",
    value: function clearTree() {
      var _this$_configProperti2;

      this.selected = false;
      (_this$_configProperti2 = this._configProperties) === null || _this$_configProperti2 === void 0 ? void 0 : _this$_configProperti2.forEach(function (property) {
        property.clearTree();
      });
    }
  }, {
    key: "makeRecursiveDefaultSelections",
    value: function makeRecursiveDefaultSelections() {
      var _this$_configProperti3;

      this._selected = true;
      (_this$_configProperti3 = this._configProperties) === null || _this$_configProperti3 === void 0 ? void 0 : _this$_configProperti3.forEach(function (property) {
        property.makeRecursiveDefaultSelections();
      });
    }
  }, {
    key: "findConfigOptionById",
    value: function findConfigOptionById(optionId) {
      var opt = null;

      if (this.optionId === optionId) {
        return opt;
      } else {
        var _this$_configProperti4;

        (_this$_configProperti4 = this._configProperties) === null || _this$_configProperti4 === void 0 ? void 0 : _this$_configProperti4.forEach(function (configProp) {
          if (!opt) {
            opt = configProp.findConfigOptionById(optionId);
          }
        });
        return opt;
      }
    }
  }, {
    key: "findSelectionTreeForOptionBySelectedId",
    value: function findSelectionTreeForOptionBySelectedId(selectedId) {
      var _this3 = this;

      var nodes = [];

      if (this.selectedId === selectedId) {
        nodes.push(this);
      } else {
        var _this$_configProperti5;

        (_this$_configProperti5 = this._configProperties) === null || _this$_configProperti5 === void 0 ? void 0 : _this$_configProperti5.forEach(function (configProp) {
          var propNodes = configProp.findSelectionTreeForOptionBySelectedId(selectedId);

          if (propNodes.length > 0) {
            nodes.push(_this3);
            nodes.push.apply(nodes, _toConsumableArray(propNodes));
          }
        });
      }

      return nodes;
    }
  }, {
    key: "findConfigOptionBySelectedId",
    value: function findConfigOptionBySelectedId(selectedId) {
      var opt = null;

      if (this.selectedId === selectedId) {
        return opt;
      } else {
        var _this$_configProperti6;

        (_this$_configProperti6 = this._configProperties) === null || _this$_configProperti6 === void 0 ? void 0 : _this$_configProperti6.forEach(function (configProp) {
          if (!opt) {
            opt = configProp.findConfigOptionBySelectedId(selectedId);
          }
        });
        return opt;
      }
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selected;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        if (val) {
          if (!_this4._parent.isMultiSelect) {
            _this4._parent.clearTree([_this4.optionId]);
          }

          _this4.makeRecursiveDefaultSelections();
        } else {
          if (!(!_this4._parent.isMultiSelect && _this4._parent.isMandatory && _this4._parent.options.length === 1)) {
            _this4._selected = val;
          }
        }
      });
    }
  }, {
    key: "propertyDirty",
    set: function set(val) {
      if (val) {
        this._parent.setIsDirty(val);
      } else {
        this._parent.setIsDirty(false, true);

        this._parent.setIsDirty(true);
      }
    }
  }, {
    key: "isInValid",
    get: function get() {
      if (this.selected) {
        var _this$_configProperti7;

        var atleastOneConfigPropertyIsInvalid = false;
        (_this$_configProperti7 = this._configProperties) === null || _this$_configProperti7 === void 0 ? void 0 : _this$_configProperti7.forEach(function (property) {
          if (property.isInValid) {
            atleastOneConfigPropertyIsInvalid = true;
          }
        });
        return atleastOneConfigPropertyIsInvalid;
      } else {
        return false;
      }
    }
  }, {
    key: "name",
    get: function get() {
      var _this$_skuBean2;

      return (_this$_skuBean2 = this._skuBean) === null || _this$_skuBean2 === void 0 ? void 0 : _this$_skuBean2.displayName;
    }
  }, {
    key: "description",
    get: function get() {
      var _this$_skuBean3;

      return (_this$_skuBean3 = this._skuBean) === null || _this$_skuBean3 === void 0 ? void 0 : _this$_skuBean3.description;
    }
  }, {
    key: "optionId",
    get: function get() {
      var _this$_skuBean4;

      return (_this$_skuBean4 = this._skuBean) === null || _this$_skuBean4 === void 0 ? void 0 : _this$_skuBean4.configOptionId;
    }
  }, {
    key: "price",
    get: function get() {
      var _this$_skuBean5, _this$_skuBean5$price;

      return (_this$_skuBean5 = this._skuBean) === null || _this$_skuBean5 === void 0 ? void 0 : (_this$_skuBean5$price = _this$_skuBean5.price) === null || _this$_skuBean5$price === void 0 ? void 0 : _this$_skuBean5$price.value;
    }
  }, {
    key: "displayPrice",
    get: function get() {
      var _this$_skuBean6, _this$_skuBean6$price;

      return this.price === 0 ? "" : (_this$_skuBean6 = this._skuBean) === null || _this$_skuBean6 === void 0 ? void 0 : (_this$_skuBean6$price = _this$_skuBean6.price) === null || _this$_skuBean6$price === void 0 ? void 0 : _this$_skuBean6$price.formattedPrice;
    }
  }, {
    key: "selectedId",
    get: function get() {
      // newSelectedId is cloud type which is equivalent to the ATG's selectedId
      return this._skuBean["newSelectedId"];
    }
  }, {
    key: "optionType",
    get: function get() {
      return this._skuBean.optionType;
    }
  }, {
    key: "mobileAppSmallImage",
    get: function get() {
      var _this$_skuBean7, _this$_skuBean7$media, _this$_skuBean7$media2;

      return (_this$_skuBean7 = this._skuBean) === null || _this$_skuBean7 === void 0 ? void 0 : (_this$_skuBean7$media = _this$_skuBean7.media) === null || _this$_skuBean7$media === void 0 ? void 0 : (_this$_skuBean7$media2 = _this$_skuBean7$media.smallImage) === null || _this$_skuBean7$media2 === void 0 ? void 0 : _this$_skuBean7$media2.url;
    }
  }, {
    key: "mobileAppLargeImage",
    get: function get() {
      var _this$_skuBean8, _this$_skuBean8$media, _this$_skuBean8$media2;

      return (_this$_skuBean8 = this._skuBean) === null || _this$_skuBean8 === void 0 ? void 0 : (_this$_skuBean8$media = _this$_skuBean8.media) === null || _this$_skuBean8$media === void 0 ? void 0 : (_this$_skuBean8$media2 = _this$_skuBean8$media.largeImage) === null || _this$_skuBean8$media2 === void 0 ? void 0 : _this$_skuBean8$media2.url;
    }
  }, {
    key: "thumbnailImage",
    get: function get() {
      var _this$_skuBean$media, _this$_skuBean$media$;

      return (_this$_skuBean$media = this._skuBean.media) === null || _this$_skuBean$media === void 0 ? void 0 : (_this$_skuBean$media$ = _this$_skuBean$media.thumbnailImage) === null || _this$_skuBean$media$ === void 0 ? void 0 : _this$_skuBean$media$.url;
    }
  }, {
    key: "isFoodItem",
    get: function get() {
      var _this$_skuBean9, _this$_skuBean9$confi;

      return (_this$_skuBean9 = this._skuBean) === null || _this$_skuBean9 === void 0 ? void 0 : (_this$_skuBean9$confi = _this$_skuBean9.configs) === null || _this$_skuBean9$confi === void 0 ? void 0 : _this$_skuBean9$confi.isFoodItem;
    }
  }, {
    key: "isAlcohol",
    get: function get() {
      var _this$_skuBean10, _this$_skuBean10$conf;

      return (_this$_skuBean10 = this._skuBean) === null || _this$_skuBean10 === void 0 ? void 0 : (_this$_skuBean10$conf = _this$_skuBean10.configs) === null || _this$_skuBean10$conf === void 0 ? void 0 : _this$_skuBean10$conf.isAlcohol;
    }
  }, {
    key: "alcoholSubClassification",
    get: function get() {
      var _this$_skuBean11;

      return (_this$_skuBean11 = this._skuBean) === null || _this$_skuBean11 === void 0 ? void 0 : _this$_skuBean11.alcoholSubClassification;
    }
  }, {
    key: "optionName",
    get: function get() {
      var _this$_skuBean12;

      return (_this$_skuBean12 = this._skuBean) === null || _this$_skuBean12 === void 0 ? void 0 : _this$_skuBean12.displayName;
    }
  }, {
    key: "heading",
    get: function get() {
      var _this$_skuBean13;

      return (_this$_skuBean13 = this._skuBean) === null || _this$_skuBean13 === void 0 ? void 0 : _this$_skuBean13.displayName;
    }
  }, {
    key: "displayName",
    get: function get() {
      var _this$_skuBean14;

      return (_this$_skuBean14 = this._skuBean) === null || _this$_skuBean14 === void 0 ? void 0 : _this$_skuBean14.displayName;
    }
  }, {
    key: "selectionDisplayName",
    get: function get() {
      var _this$_skuBean15;

      return (_this$_skuBean15 = this._skuBean) === null || _this$_skuBean15 === void 0 ? void 0 : _this$_skuBean15.longDescription;
    }
  }, {
    key: "selectedIds",
    get: function get() {
      return this.selectedConfigOptions.map(function (opt) {
        return opt.selectedId;
      });
    }
  }, {
    key: "selectedConfigOptions",
    get: function get() {
      var opts = [];

      if (this.selected) {
        var _this$_configProperti8;

        opts.push(this);
        (_this$_configProperti8 = this._configProperties) === null || _this$_configProperti8 === void 0 ? void 0 : _this$_configProperti8.forEach(function (configProp) {
          var selectedConfigOptions = configProp.selectedConfigOptions;
          opts = opts.concat(selectedConfigOptions);
        });
      }

      return opts;
    }
  }, {
    key: "selectedConfigOptionsPrice",
    get: function get() {
      return this.selectedConfigOptions.reduce(function (total, configOpt) {
        return configOpt.price && configOpt.price > 0 ? total + configOpt.price : total;
      }, 0);
    }
  }, {
    key: "skuDisplayName",
    get: function get() {
      var _this$_skuBean16;

      return (_this$_skuBean16 = this._skuBean) === null || _this$_skuBean16 === void 0 ? void 0 : _this$_skuBean16.displayName;
    }
  }, {
    key: "isBeverageItem",
    get: function get() {
      var _this$_skuBean17, _this$_skuBean17$conf;

      return (_this$_skuBean17 = this._skuBean) === null || _this$_skuBean17 === void 0 ? void 0 : (_this$_skuBean17$conf = _this$_skuBean17.configs) === null || _this$_skuBean17$conf === void 0 ? void 0 : _this$_skuBean17$conf.isBeverageItem;
    }
  }]);

  return ConfigOption;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_skuBean", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_configProperties", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_selected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "options", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "options"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "depth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "depth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parent", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "parent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "makeOptionsAsListWithCarousels", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "makeOptionsAsListWithCarousels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "variant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "variant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "floor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "floor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pretty", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pretty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isInValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isInValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "makeRecursiveDefaultSelections", [action], Object.getOwnPropertyDescriptor(_class.prototype, "makeRecursiveDefaultSelections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "price", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "price"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobileAppSmallImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobileAppSmallImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mobileAppLargeImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mobileAppLargeImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "thumbnailImage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "thumbnailImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFoodItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFoodItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAlcohol", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAlcohol"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "alcoholSubClassification", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "alcoholSubClassification"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "heading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "heading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectionDisplayName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectionDisplayName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedConfigOptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedConfigOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedConfigOptionsPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedConfigOptionsPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skuDisplayName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "skuDisplayName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isBeverageItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBeverageItem"), _class.prototype)), _class));
export { ConfigOption as default };